// List of words for Imposter game
// Total: 200 words across 12 categories

export const wordList = [
    // ==================== COMMON ITEMS ====================
    // Everyday objects people recognize
    "Pizza",
    "Umbrella",
    "Laptop",
    "Sunglasses",
    "Bicycle",
    "Coffee",
    "Camera",
    "Backpack",
    "Smartphone",
    "Headphones",
    "Passport",
    "Skateboard",
    "Microwave",
    "Toothbrush",
    "Wallet",
    "Keys",
    "Clock",
    "Mirror",
    "Candle",
    "Pillow",
    "Scissors",
    "Lamp",
    "Pencil",
    "Chair",
    "Blanket",

    // ==================== FOOD & DRINKS ====================
    // Popular foods that people can describe
    "Sushi",
    "Tacos",
    "Burger",
    "Ice Cream",
    "Chocolate",
    "Sandwich",
    "Spaghetti",
    "Ramen",
    "Pancakes",
    "Donut",
    "Salad",
    "Soup",
    "Steak",
    "Chicken Wings",
    "French Fries",
    "Popcorn",
    "Cookies",
    "Cupcake",
    "Smoothie",
    "Lemonade",
    "Hot Dog",
    "Nachos",
    "Cereal",
    "Yogurt",
    "Cheese",

    // ==================== ACTIVITIES & SPORTS ====================
    // Physical activities and hobbies
    "Basketball",
    "Swimming",
    "Dancing",
    "Cooking",
    "Reading",
    "Singing",
    "Running",
    "Painting",
    "Gaming",
    "Hiking",
    "Soccer",
    "Baseball",
    "Tennis",
    "Skateboarding",
    "Yoga",
    "Fishing",
    "Camping",
    "Photography",
    "Drawing",
    "Surfing",
    "Skiing",
    "Bowling",
    "Karaoke",
    "Gardening",
    "Cycling",

    // ==================== PLACES ====================
    // Locations people visit or know about
    "Ocean",
    "Mountain",
    "Desert",
    "Forest",
    "Beach",
    "Library",
    "Hospital",
    "Airport",
    "Museum",
    "Stadium",
    "Restaurant",
    "Mall",
    "Park",
    "School",
    "Cinema",
    "Gym",
    "Zoo",
    "Aquarium",
    "Hotel",
    "Cafe",
    "Playground",
    "Casino",
    "Concert Hall",
    "Bakery",
    "Bank",

    // ==================== ANIMALS ====================
    // Easy to describe animals
    "Elephant",
    "Dolphin",
    "Eagle",
    "Lion",
    "Penguin",
    "Butterfly",
    "Shark",
    "Giraffe",
    "Owl",
    "Tiger",
    "Monkey",
    "Bear",
    "Fox",
    "Rabbit",
    "Horse",
    "Dog",
    "Cat",
    "Parrot",
    "Kangaroo",
    "Zebra",
    "Turtle",
    "Crocodile",
    "Snake",
    "Octopus",
    "Whale",

    // ==================== FAMOUS PEOPLE ====================
    // Well-known real people across different fields
    "Einstein",
    "Shakespeare",
    "Beyoncé",
    "Messi",
    "Oprah",
    "Tesla",
    "Mozart",
    "Cleopatra",
    "Obama",
    "LeBron James",
    "Michael Jordan",
    "Taylor Swift",
    "Elon Musk",
    "Steve Jobs",
    "Ronaldo",
    "Lady Gaga",
    "Elvis Presley",
    "Michael Jackson",
    "Tom Cruise",
    "The Rock",

    // ==================== FICTIONAL CHARACTERS ====================
    // Iconic characters from movies, games, comics, books
    "Batman",
    "Superman",
    "Spider-Man",
    "Harry Potter",
    "Elsa",
    "Darth Vader",
    "Mario",
    "Pikachu",
    "Sherlock Holmes",
    "Mickey Mouse",
    "Iron Man",
    "Wonder Woman",
    "Sonic",
    "Link",
    "Hermione",
    "Joker",
    "Luke Skywalker",
    "Yoda",
    "Hulk",
    "Thor",
    "Captain America",
    "Spongebob",
    "Shrek",
    "Buzz Lightyear",
    "Woody",

    // ==================== PROFESSIONS ====================
    // Jobs and careers
    "Doctor",
    "Teacher",
    "Chef",
    "Police Officer",
    "Firefighter",
    "Pilot",
    "Nurse",
    "Engineer",
    "Lawyer",
    "Dentist",
    "Musician",
    "Actor",
    "Athlete",
    "Artist",
    "Scientist",
    "Farmer",
    "Mechanic",
    "Architect",
    "Plumber",
    "Electrician",

    // ==================== VEHICLES & TRANSPORTATION ====================
    // Ways to get around
    "Car",
    "Airplane",
    "Boat",
    "Train",
    "Helicopter",
    "Motorcycle",
    "Bus",
    "Truck",
    "Submarine",
    "Rocket",
    "Ambulance",
    "Taxi",
    "Scooter",
    "Hot Air Balloon",
    "Yacht",

    // ==================== TECHNOLOGY ====================
    // Tech and gadgets
    "Computer",
    "Tablet",
    "Television",
    "Robot",
    "Drone",
    "Video Game Console",
    "Smartwatch",
    "VR Headset",
    "Speaker",
    "Printer",
    "Keyboard",
    "Mouse",
    "Charger",
    "Remote Control",
    "GPS",

    // ==================== NATURE & WEATHER ====================
    // Natural phenomena and elements
    "Rainbow",
    "Lightning",
    "Volcano",
    "Earthquake",
    "Tornado",
    "Hurricane",
    "Sunset",
    "Moon",
    "Stars",
    "Clouds",
    "Rain",
    "Snow",
    "Thunder",
    "Wind",
    "Fog",

    // ==================== ENTERTAINMENT ====================
    // Movies, shows, bands, entertainment brands
    "Star Wars",
    "Marvel",
    "Disney",
    "Netflix",
    "YouTube",
    "TikTok",
    "Instagram",
    "Spotify",
    "Minecraft",
    "Fortnite",
    "Pokemon",
    "The Beatles",
    "Game of Thrones",
    "Friends",
    "The Office",
];

const expansionWords = [
    "Notebook", "Marker", "Stapler", "Whiteboard", "Water Bottle", "Phone Charger", "Hair Dryer", "Earbuds", "Hammock", "Flashlight",
    "Binoculars", "Compass", "Measuring Tape", "Toolbox", "Paint Roller", "Rolling Pin", "Cutting Board", "Blender", "Pressure Cooker", "Vacuum",
    "Mop", "Dishwasher", "Washer", "Dryer", "Bookshelf", "Coffee Table", "Nightstand", "Desk Fan", "Air Purifier", "Humidifier",
    "Game Controller", "Board Game", "Dice", "Playing Cards", "Jigsaw Puzzle", "Hoodie", "Sneakers", "Jacket", "Raincoat", "Hat",
    "Scarf", "Gloves", "Necktie", "Watch", "Bracelet", "Necklace", "Ring", "Socks", "Suitcase", "Duffel Bag",
    "Tent", "Sleeping Bag", "Camping Stove", "First Aid Kit", "Power Bank", "Tripod", "Projector", "Microphone", "Drumsticks", "Guitar Pick",
    "Samosa", "Burrito", "Paella", "Lasagna", "Dumplings", "Gnocchi", "Risotto", "Paella", "Fajitas", "Quesadilla",
    "Falafel", "Hummus", "Curry", "Biryani", "Kimchi", "Bibimbap", "Tempura", "Udon", "Sashimi", "Bagel",
    "Muffin", "Brownie", "Cheesecake", "Tiramisu", "Pudding", "Waffles", "Crepe", "Macaron", "Pie", "Pretzel",
    "Granola", "Omelet", "Avocado Toast", "Mashed Potatoes", "Roast Chicken", "Meatloaf", "Lasagna", "Stuffed Peppers", "Salsa", "Guacamole",
    "Pickles", "Jam", "Peanut Butter", "Honey", "Iced Tea", "Milkshake", "Espresso", "Latte", "Green Tea", "Coconut Water",
    "Volleyball", "Badminton", "Table Tennis", "Rugby", "Cricket", "Archery", "Fencing", "Rowing", "Boxing", "Wrestling",
    "Pilates", "Meditation", "Knitting", "Sewing", "Woodworking", "Pottery", "Origami", "Calligraphy", "Puzzles", "Chess",
    "Checkers", "Billiards", "Darts", "Snowboarding", "Rock Climbing", "Trail Running", "Kickboxing", "Weightlifting", "Jump Rope", "Frisbee",
    "Waterfall", "Canyon", "Valley", "Island", "Village", "Capitol", "Courthouse", "Police Station", "Fire Station", "Train Station",
    "Bus Stop", "Harbor", "Port", "Lighthouse", "Bridge", "Tunnel", "Highway", "Farm", "Ranch", "Greenhouse",
    "Factory", "Warehouse", "Office", "Studio", "Laboratory", "Planetarium", "Observatory", "Amusement Park", "Theme Park", "Ice Rink",
    "Skate Park", "Dog Park", "Campground", "Hostel", "Resort", "Cabin", "Temple", "Mosque", "Cathedral", "Monument",
    "Koala", "Panda", "Wolf", "Moose", "Deer", "Goat", "Sheep", "Cow", "Pig", "Chicken",
    "Duck", "Goose", "Flamingo", "Peacock", "Falcon", "Hawk", "Crow", "Raven", "Swan", "Seahorse",
    "Jellyfish", "Lobster", "Crab", "Starfish", "Seal", "Otter", "Bison", "Buffalo", "Leopard", "Cheetah",
    "Hyena", "Rhinoceros", "Hippo", "Camel", "Llama", "Alpaca", "Chameleon", "Iguana", "Frog", "Toad",
    "Bee", "Ant", "Ladybug", "Dragonfly", "Caterpillar", "Moth", "Hamster", "Guinea Pig", "Ferret", "Hedgehog",
    "Astronaut", "Journalist", "Photographer", "Programmer", "Designer", "Product Manager", "Data Analyst", "Accountant", "Pharmacist", "Veterinarian",
    "Therapist", "Psychologist", "Counselor", "Paramedic", "Librarian", "Translator", "Interpreter", "Barista", "Baker", "Butcher",
    "Florist", "Tailor", "Hair Stylist", "Makeup Artist", "Event Planner", "Real Estate Agent", "Entrepreneur", "Cashier", "Receptionist", "Security Guard",
    "Tractor", "Bulldozer", "Forklift", "Jet Ski", "Skate", "Segway", "Monorail", "Tram", "Cable Car", "Race Car",
    "Satellite", "Space Station", "Electric Car", "Self-Driving Car", "3D Printer", "Smart Glasses", "E-reader", "Webcam", "Router", "Hard Drive",
    "Cloud Server", "Podcast", "Live Stream", "Arcade", "Puzzle Game", "Strategy Game", "Racing Game", "Horror Movie", "Documentary", "Podcast Episode",
    "Blizzard", "Heatwave", "Drought", "Avalanche", "Tsunami", "Meteor", "Comet", "Galaxy", "Nebula", "Aurora",
    "Constellation", "Solar Eclipse", "Lunar Eclipse", "Spring", "Summer", "Autumn", "Winter", "Cliff", "Cave", "Glacier"
];

wordList.push(...expansionWords);

// Optional: Category definitions for base pack (first 250 words)
// Expanded library now includes 560 total words.
export const categories = {
    "Common Items": { start: 0, count: 25 },
    "Food & Drinks": { start: 25, count: 25 },
    "Activities & Sports": { start: 50, count: 25 },
    "Places": { start: 75, count: 25 },
    "Animals": { start: 100, count: 25 },
    "Famous People": { start: 125, count: 20 },
    "Fictional Characters": { start: 145, count: 25 },
    "Professions": { start: 170, count: 20 },
    "Vehicles": { start: 190, count: 15 },
    "Technology": { start: 205, count: 15 },
    "Nature & Weather": { start: 220, count: 15 },
    "Entertainment": { start: 235, count: 15 },
};

// Helper function to get random word
export const getRandomWord = () => {
    return wordList[Math.floor(Math.random() * wordList.length)];
};

// Helper function to get words by category (future feature)
export const getWordsByCategory = (categoryName) => {
    const category = categories[categoryName];
    if (!category) return [];
    return wordList.slice(category.start, category.start + category.count);
};

// Helper function to get random word from specific category (future feature)
export const getRandomWordFromCategory = (categoryName) => {
    const categoryWords = getWordsByCategory(categoryName);
    if (categoryWords.length === 0) return null;
    return categoryWords[Math.floor(Math.random() * categoryWords.length)];
};

// ==================== HINTS FOR IMPOSTERS ====================
// 7-10 simple related words per word to help imposters blend in

export const wordHints = {
    // COMMON ITEMS
    "Pizza": ["Italian", "Cheese", "Tomato", "Round", "Slice", "Pepperoni", "Dough", "Oven", "Delivery"],
    "Umbrella": ["Rain", "Cover", "Open", "Handle", "Waterproof", "Portable", "Weather", "Protection", "Fold"],
    "Laptop": ["Computer", "Screen", "Keyboard", "Portable", "Battery", "Internet", "Work", "Type", "Programs"],
    "Sunglasses": ["Eyes", "UV", "Summer", "Fashion", "Dark", "Lenses", "Beach", "Protect", "Shade"],
    "Bicycle": ["Wheels", "Pedals", "Chain", "Handlebars", "Exercise", "Transport", "Road", "Ride", "Gears"],
    "Coffee": ["Caffeine", "Hot", "Morning", "Brown", "Beans", "Cup", "Espresso", "Energy", "Bitter"],
    "Camera": ["Photo", "Lens", "Picture", "Memory", "Capture", "Click", "Digital", "Flash", "Focus"],
    "Backpack": ["Bag", "Carry", "Straps", "School", "Storage", "Travel", "Zipper", "Shoulder", "Pack"],
    "Smartphone": ["Mobile", "Apps", "Screen", "Call", "Text", "Internet", "Touch", "Pocket", "Camera"],
    "Headphones": ["Music", "Ears", "Sound", "Audio", "Listen", "Wire", "Volume", "Noise", "Wireless"],
    "Passport": ["Travel", "Identity", "Document", "Photo", "Country", "Visa", "Stamp", "Border", "Pages"],
    "Skateboard": ["Board", "Wheels", "Tricks", "Deck", "Roll", "Street", "Skate", "Park", "Balance"],
    "Microwave": ["Heat", "Food", "Quick", "Kitchen", "Waves", "Timer", "Beep", "Cook", "Reheat"],
    "Toothbrush": ["Teeth", "Bristles", "Clean", "Paste", "Morning", "Mouth", "Hygiene", "Scrub", "Handle"],
    "Wallet": ["Money", "Cards", "Pocket", "Leather", "Cash", "Fold", "ID", "Bills", "Carry"],
    "Keys": ["Lock", "Metal", "Door", "Unlock", "Ring", "Jingle", "Car", "Home", "Open"],
    "Clock": ["Time", "Hours", "Minutes", "Tick", "Alarm", "Wall", "Watch", "Face", "Hands"],
    "Mirror": ["Reflection", "Glass", "Look", "Image", "Wall", "Bathroom", "See", "Face", "Shiny"],
    "Candle": ["Wax", "Flame", "Light", "Wick", "Burn", "Scent", "Romantic", "Dark", "Melt"],
    "Pillow": ["Sleep", "Soft", "Head", "Bed", "Cushion", "Rest", "Comfort", "Fluffy", "Night"],
    "Scissors": ["Cut", "Blade", "Sharp", "Snip", "Paper", "Two", "Handles", "Metal", "Craft"],
    "Lamp": ["Light", "Bulb", "Desk", "Shade", "Plug", "Switch", "Bright", "Dark", "Electric"],
    "Pencil": ["Write", "Lead", "Graphite", "Eraser", "Wood", "Draw", "Sketch", "Point", "School"],
    "Chair": ["Sit", "Legs", "Back", "Furniture", "Wood", "Comfort", "Seat", "Table", "Rest"],
    "Blanket": ["Warm", "Soft", "Cover", "Bed", "Cozy", "Sleep", "Fabric", "Cold", "Wrap"],

    // FOOD & DRINKS
    "Sushi": ["Japanese", "Rice", "Raw", "Fish", "Roll", "Seaweed", "Wasabi", "Soy", "Chopsticks"],
    "Tacos": ["Mexican", "Shell", "Meat", "Lettuce", "Cheese", "Salsa", "Wrap", "Spicy", "Crunchy"],
    "Burger": ["Beef", "Bun", "Patty", "Cheese", "Lettuce", "Tomato", "Fast", "Grill", "Pickles"],
    "Ice Cream": ["Cold", "Sweet", "Cream", "Flavor", "Cone", "Scoop", "Dessert", "Melt", "Frozen"],
    "Chocolate": ["Sweet", "Brown", "Cocoa", "Candy", "Bar", "Melt", "Dessert", "Sugar", "Dark"],
    "Sandwich": ["Bread", "Slice", "Meat", "Cheese", "Lunch", "Layers", "Toasted", "Filling", "Cut"],
    "Spaghetti": ["Pasta", "Italian", "Noodles", "Sauce", "Long", "Tomato", "Fork", "Meatballs", "Twirl"],
    "Ramen": ["Noodles", "Japanese", "Soup", "Bowl", "Hot", "Broth", "Slurp", "Quick", "Flavor"],
    "Pancakes": ["Breakfast", "Flat", "Syrup", "Stack", "Butter", "Flip", "Griddle", "Sweet", "Round"],
    "Donut": ["Sweet", "Round", "Hole", "Fried", "Glazed", "Sprinkles", "Breakfast", "Sugar", "Bakery"],
    "Salad": ["Healthy", "Green", "Lettuce", "Vegetables", "Fresh", "Bowl", "Dressing", "Crisp", "Raw"],
    "Soup": ["Hot", "Liquid", "Bowl", "Spoon", "Broth", "Warm", "Comfort", "Sip", "Steam"],
    "Steak": ["Beef", "Meat", "Grill", "Juicy", "Cooked", "Rare", "Cut", "Knife", "Protein"],
    "Chicken Wings": ["Meat", "Sauce", "Spicy", "Buffalo", "Fried", "Bones", "Ranch", "Hot", "Finger"],
    "French Fries": ["Potato", "Fried", "Crispy", "Salt", "Golden", "Side", "Ketchup", "Fast", "Thin"],
    "Popcorn": ["Corn", "Pop", "Butter", "Movie", "Snack", "Bowl", "Crunchy", "Salt", "Theater"],
    "Cookies": ["Sweet", "Baked", "Chocolate", "Chip", "Dough", "Round", "Crunchy", "Dessert", "Jar"],
    "Cupcake": ["Sweet", "Small", "Frosting", "Cake", "Icing", "Sprinkles", "Dessert", "Party", "Wrapper"],
    "Smoothie": ["Blend", "Fruit", "Drink", "Thick", "Healthy", "Cold", "Straw", "Sweet", "Vitamin"],
    "Lemonade": ["Lemon", "Sweet", "Sour", "Yellow", "Cold", "Drink", "Summer", "Refreshing", "Pitcher"],
    "Hot Dog": ["Sausage", "Bun", "Mustard", "Ketchup", "Baseball", "Street", "Fast", "Long", "Grilled"],
    "Nachos": ["Chips", "Cheese", "Mexican", "Melted", "Jalapeño", "Crunchy", "Salsa", "Share", "Plate"],
    "Cereal": ["Breakfast", "Milk", "Bowl", "Crunchy", "Morning", "Spoon", "Box", "Sweet", "Cold"],
    "Yogurt": ["Dairy", "Thick", "Fruit", "Spoon", "Healthy", "Breakfast", "Creamy", "Culture", "Container"],
    "Cheese": ["Dairy", "Yellow", "Melted", "Sharp", "Slice", "Milk", "Aged", "Flavor", "Holes"],

    // ACTIVITIES & SPORTS
    "Basketball": ["Ball", "Hoop", "Court", "Dribble", "Shoot", "Team", "NBA", "Jump", "Orange"],
    "Swimming": ["Water", "Pool", "Stroke", "Dive", "Float", "Lap", "Goggles", "Splash", "Wet"],
    "Dancing": ["Music", "Move", "Rhythm", "Steps", "Beat", "Performance", "Partner", "Stage", "Groove"],
    "Cooking": ["Kitchen", "Food", "Recipe", "Heat", "Ingredients", "Chef", "Stove", "Prepare", "Taste"],
    "Reading": ["Book", "Words", "Pages", "Story", "Quiet", "Learn", "Eyes", "Library", "Comprehend"],
    "Singing": ["Voice", "Music", "Song", "Melody", "Lyrics", "Pitch", "Tune", "Perform", "Notes"],
    "Running": ["Fast", "Jog", "Feet", "Exercise", "Track", "Marathon", "Speed", "Pace", "Breathe"],
    "Painting": ["Art", "Brush", "Color", "Canvas", "Creative", "Palette", "Strokes", "Picture", "Paint"],
    "Gaming": ["Video", "Console", "Controller", "Play", "Screen", "Fun", "Online", "Level", "Win"],
    "Hiking": ["Trail", "Mountain", "Walk", "Nature", "Boots", "Backpack", "Climb", "Path", "Adventure"],
    "Soccer": ["Ball", "Goal", "Kick", "Field", "Team", "Cleats", "Run", "Pass", "World"],
    "Baseball": ["Bat", "Ball", "Diamond", "Pitch", "Home", "Strike", "Glove", "Team", "Catch"],
    "Tennis": ["Racket", "Ball", "Court", "Net", "Serve", "Match", "Love", "Swing", "Bounce"],
    "Skateboarding": ["Board", "Wheels", "Tricks", "Ramp", "Flip", "Grind", "Street", "Helmet", "Roll"],
    "Yoga": ["Stretch", "Balance", "Pose", "Mat", "Breathing", "Flexible", "Exercise", "Calm", "Peace"],
    "Fishing": ["Rod", "Water", "Catch", "Bait", "Reel", "Lake", "Boat", "Hook", "Patience"],
    "Camping": ["Tent", "Outdoor", "Nature", "Sleep", "Fire", "Forest", "Adventure", "Wildlife", "Stars"],
    "Photography": ["Camera", "Picture", "Lens", "Capture", "Focus", "Shot", "Photo", "Frame", "Exposure"],
    "Drawing": ["Pencil", "Sketch", "Paper", "Art", "Lines", "Creative", "Image", "Shading", "Doodle"],
    "Surfing": ["Wave", "Ocean", "Board", "Balance", "Ride", "Beach", "Wetsuit", "Paddle", "Splash"],
    "Skiing": ["Snow", "Mountain", "Slopes", "Cold", "Poles", "Downhill", "Lift", "Fast", "Winter"],
    "Bowling": ["Ball", "Pins", "Strike", "Lane", "Roll", "Shoes", "Alley", "Score", "Ten"],
    "Karaoke": ["Singing", "Microphone", "Lyrics", "Song", "Stage", "Bar", "Music", "Performance", "Fun"],
    "Gardening": ["Plants", "Soil", "Water", "Grow", "Flowers", "Seeds", "Tools", "Outside", "Green"],
    "Cycling": ["Bike", "Pedal", "Ride", "Road", "Wheels", "Exercise", "Tour", "Helmet", "Speed"],

    // PLACES
    "Ocean": ["Water", "Salty", "Blue", "Waves", "Deep", "Fish", "Vast", "Swim", "Ships"],
    "Mountain": ["High", "Peak", "Climb", "Tall", "Rock", "Summit", "View", "Snow", "Hike"],
    "Desert": ["Sand", "Hot", "Dry", "Dunes", "Cactus", "Barren", "Sun", "Arid", "Empty"],
    "Forest": ["Trees", "Woods", "Green", "Nature", "Animals", "Dense", "Leaves", "Wild", "Trail"],
    "Beach": ["Sand", "Ocean", "Wave", "Sunny", "Coast", "Swim", "Vacation", "Towel", "Seashell"],
    "Library": ["Books", "Quiet", "Reading", "Shelves", "Study", "Borrow", "Information", "Silent", "Learning"],
    "Hospital": ["Doctor", "Medicine", "Sick", "Emergency", "Nurse", "Beds", "Treatment", "Health", "Care"],
    "Airport": ["Plane", "Flight", "Travel", "Terminal", "Luggage", "Security", "Passport", "Departure", "Boarding"],
    "Museum": ["Art", "History", "Exhibits", "Culture", "Gallery", "Artifacts", "Display", "Old", "Tour"],
    "Stadium": ["Sports", "Crowd", "Game", "Seats", "Cheer", "Field", "Large", "Events", "Team"],
    "Restaurant": ["Food", "Menu", "Waiter", "Table", "Eat", "Order", "Chef", "Dinner", "Service"],
    "Mall": ["Shopping", "Stores", "Clothes", "Food", "Indoor", "Escalator", "Browse", "Purchase", "Crowded"],
    "Park": ["Green", "Trees", "Grass", "Play", "Bench", "Walk", "Nature", "Recreation", "Path"],
    "School": ["Learn", "Students", "Teachers", "Class", "Books", "Study", "Education", "Desk", "Homework"],
    "Cinema": ["Movies", "Screen", "Popcorn", "Theater", "Watch", "Films", "Seats", "Dark", "Entertainment"],
    "Gym": ["Exercise", "Weights", "Fitness", "Workout", "Muscle", "Treadmill", "Sweat", "Membership", "Equipment"],
    "Zoo": ["Animals", "Cages", "Wild", "Visit", "Tigers", "Elephants", "Exhibits", "Safari", "Conservation"],
    "Aquarium": ["Fish", "Water", "Glass", "Marine", "Tanks", "Ocean", "Sea", "Coral", "Underwater"],
    "Hotel": ["Sleep", "Room", "Bed", "Vacation", "Stay", "Service", "Lobby", "Check-in", "Travel"],
    "Cafe": ["Coffee", "Drinks", "Relax", "Small", "Cozy", "Tables", "Chat", "Snacks", "Casual"],
    "Playground": ["Kids", "Slide", "Swing", "Fun", "Play", "Outdoor", "Sandbox", "Jungle", "Children"],
    "Casino": ["Gambling", "Cards", "Slots", "Bet", "Money", "Chips", "Luck", "Vegas", "Win"],
    "Concert Hall": ["Music", "Performance", "Stage", "Audience", "Orchestra", "Sound", "Show", "Seats", "Live"],
    "Bakery": ["Bread", "Pastry", "Fresh", "Oven", "Sweet", "Dough", "Smell", "Bake", "Flour"],
    "Bank": ["Money", "Account", "Vault", "Safe", "Teller", "Cash", "Deposit", "ATM", "Financial"],

    // ANIMALS
    "Elephant": ["Trunk", "Large", "Gray", "Tusks", "Memory", "Africa", "Ears", "Heavy", "Intelligent"],
    "Dolphin": ["Ocean", "Smart", "Jump", "Swim", "Friendly", "Marine", "Playful", "Gray", "Mammal"],
    "Eagle": ["Bird", "Fly", "Predator", "Sharp", "Talons", "Bald", "Sky", "Hunt", "Majestic"],
    "Lion": ["King", "Mane", "Roar", "Safari", "Predator", "Pride", "Savanna", "Carnivore", "Fierce"],
    "Penguin": ["Ice", "Black", "White", "Waddle", "Swim", "Antarctica", "Birds", "Slide", "Colony"],
    "Butterfly": ["Wings", "Colorful", "Insect", "Fly", "Flutter", "Beautiful", "Garden", "Metamorphosis", "Delicate"],
    "Shark": ["Ocean", "Teeth", "Predator", "Fin", "Dangerous", "Swimming", "Fear", "Gray", "Hunter"],
    "Giraffe": ["Tall", "Neck", "Spots", "Long", "Africa", "Leaves", "Pattern", "Gentle", "Tongue"],
    "Owl": ["Bird", "Night", "Hoot", "Wise", "Eyes", "Nocturnal", "Feathers", "Hunt", "Silent"],
    "Tiger": ["Stripes", "Orange", "Jungle", "Predator", "Fierce", "Big", "Hunting", "Roar", "Endangered"],
    "Monkey": ["Banana", "Tree", "Swing", "Primate", "Tail", "Playful", "Jungle", "Climb", "Smart"],
    "Bear": ["Fur", "Claws", "Large", "Honey", "Hibernate", "Forest", "Strong", "Growl", "Wild"],
    "Fox": ["Clever", "Red", "Sly", "Tail", "Forest", "Cunning", "Quick", "Hunt", "Wild"],
    "Rabbit": ["Hop", "Ears", "Carrot", "Fluffy", "Fast", "Burrow", "Cute", "Whiskers", "Tail"],
    "Horse": ["Ride", "Gallop", "Mane", "Hooves", "Saddle", "Fast", "Strong", "Stable", "Farm"],
    "Dog": ["Bark", "Loyal", "Pet", "Tail", "Friend", "Puppy", "Walk", "Fetch", "Companion"],
    "Cat": ["Meow", "Purr", "Whiskers", "Paw", "Pet", "Independent", "Soft", "Kitten", "Curious"],
    "Parrot": ["Colorful", "Bird", "Talk", "Tropical", "Beak", "Feathers", "Repeat", "Wings", "Squawk"],
    "Kangaroo": ["Jump", "Pouch", "Australia", "Hop", "Marsupial", "Tail", "Strong", "Boxing", "Joey"],
    "Zebra": ["Stripes", "Black", "White", "Africa", "Horse", "Pattern", "Herd", "Savanna", "Wild"],
    "Turtle": ["Shell", "Slow", "Green", "Reptile", "Ocean", "Patient", "Flippers", "Ancient", "Hard"],
    "Crocodile": ["Reptile", "Water", "Teeth", "Dangerous", "Swamp", "Predator", "Scales", "Snap", "Large"],
    "Snake": ["Reptile", "Slither", "Scales", "Hiss", "Long", "Fangs", "Cold", "Shed", "Venom"],
    "Octopus": ["Tentacles", "Eight", "Ocean", "Ink", "Smart", "Suckers", "Camouflage", "Underwater", "Flexible"],
    "Whale": ["Ocean", "Large", "Mammal", "Blue", "Blowhole", "Swim", "Deep", "Song", "Massive"],

    // FAMOUS PEOPLE
    "Einstein": ["Smart", "Genius", "Physics", "Theory", "Relativity", "Science", "Hair", "Math", "Formula"],
    "Shakespeare": ["Writer", "Plays", "England", "Romeo", "Theater", "Poetry", "Literature", "Hamlet", "Classic"],
    "Beyoncé": ["Singer", "Music", "Queen", "Performer", "Dance", "Pop", "Celebrity", "Talent", "Icon"],
    "Messi": ["Soccer", "Football", "Argentina", "Goal", "Player", "Barcelona", "Sport", "Legend", "Dribble"],
    "Oprah": ["Talk", "Show", "Media", "Billionaire", "Influential", "Television", "Books", "Interview", "Success"],
    "Tesla": ["Inventor", "Electric", "Science", "Genius", "Coil", "Electricity", "Engineer", "Innovation", "AC"],
    "Mozart": ["Composer", "Music", "Classical", "Genius", "Piano", "Symphony", "Austria", "Prodigy", "Opera"],
    "Cleopatra": ["Egypt", "Queen", "Ancient", "Pharaoh", "Beauty", "History", "Powerful", "Ruler", "Nile"],
    "Obama": ["President", "USA", "Leader", "Politics", "Hope", "Change", "Democrat", "Speech", "First"],
    "LeBron James": ["Basketball", "NBA", "Player", "Champion", "Athletic", "King", "Lakers", "Sport", "Star"],
    "Michael Jordan": ["Basketball", "NBA", "Bulls", "Legend", "Champion", "Air", "Best", "Sport", "Icon"],
    "Taylor Swift": ["Singer", "Music", "Pop", "Country", "Songwriter", "Celebrity", "Albums", "Concert", "Famous"],
    "Elon Musk": ["Billionaire", "Tesla", "SpaceX", "Entrepreneur", "Tech", "Innovation", "Mars", "Electric", "Twitter"],
    "Steve Jobs": ["Apple", "Tech", "iPhone", "Innovation", "CEO", "Visionary", "Computer", "Design", "Genius"],
    "Ronaldo": ["Soccer", "Football", "Portugal", "Goal", "Athlete", "Star", "Champion", "CR7", "Sport"],
    "Lady Gaga": ["Singer", "Pop", "Music", "Fashion", "Performer", "Unique", "Celebrity", "Dance", "Fame"],
    "Elvis Presley": ["Singer", "Rock", "King", "Music", "Legend", "Vegas", "Dance", "Icon", "Hair"],
    "Michael Jackson": ["Singer", "Pop", "Dance", "King", "Moonwalk", "Music", "Thriller", "Legend", "Performer"],
    "Tom Cruise": ["Actor", "Movies", "Hollywood", "Mission", "Star", "Action", "Celebrity", "Film", "Smile"],
    "The Rock": ["Actor", "WWE", "Strong", "Wrestler", "Movies", "Muscles", "Hollywood", "Action", "Charisma"],

    // FICTIONAL CHARACTERS
    "Batman": ["Hero", "Dark", "Cape", "Gotham", "Bat", "Rich", "Justice", "Vigilante", "Night"],
    "Superman": ["Hero", "Cape", "Fly", "Strong", "Kryptonite", "Clark", "Powers", "Red", "Blue"],
    "Spider-Man": ["Hero", "Web", "Spider", "Climb", "Mask", "Marvel", "Peter", "Red", "Swing"],
    "Harry Potter": ["Wizard", "Magic", "Wand", "Hogwarts", "Scar", "Glasses", "Britain", "Book", "Lightning"],
    "Elsa": ["Queen", "Ice", "Frozen", "Powers", "Sister", "Disney", "Snow", "Princess", "Song"],
    "Darth Vader": ["Dark", "Mask", "Space", "Villain", "Father", "Force", "Breathing", "Lightsaber", "Empire"],
    "Mario": ["Plumber", "Jump", "Red", "Mustache", "Game", "Italian", "Princess", "Brother", "Nintendo"],
    "Pikachu": ["Yellow", "Electric", "Pokemon", "Mouse", "Cute", "Thunder", "Ash", "Lightning", "Ears"],
    "Sherlock Holmes": ["Detective", "Smart", "British", "Mystery", "Pipe", "Watson", "Solve", "London", "Clues"],
    "Mickey Mouse": ["Disney", "Mouse", "Ears", "Black", "Cartoon", "Famous", "Icon", "Gloves", "Shorts"],
    "Iron Man": ["Hero", "Suit", "Tech", "Rich", "Tony", "Armor", "Marvel", "Genius", "Red"],
    "Wonder Woman": ["Hero", "Amazon", "Strong", "Lasso", "Princess", "Warrior", "Justice", "Tiara", "Bracelets"],
    "Sonic": ["Fast", "Blue", "Hedgehog", "Speed", "Game", "Run", "Rings", "Spin", "Sega"],
    "Link": ["Hero", "Sword", "Green", "Zelda", "Adventure", "Game", "Shield", "Quest", "Nintendo"],
    "Hermione": ["Witch", "Smart", "Book", "Harry", "Magic", "Clever", "Wand", "Student", "Friend"],
    "Joker": ["Villain", "Clown", "Crazy", "Batman", "Purple", "Green", "Laugh", "Chaos", "Evil"],
    "Luke Skywalker": ["Jedi", "Force", "Lightsaber", "Hero", "Space", "Father", "Farm", "Destiny", "Hope"],
    "Yoda": ["Jedi", "Green", "Small", "Wise", "Force", "Master", "Old", "Speak", "Train"],
    "Hulk": ["Green", "Strong", "Angry", "Smash", "Big", "Hero", "Bruce", "Monster", "Powerful"],
    "Thor": ["God", "Hammer", "Thunder", "Strong", "Marvel", "Asgard", "Lightning", "Norse", "Hero"],
    "Captain America": ["Hero", "Shield", "Soldier", "Star", "Marvel", "Leader", "Brave", "Patriotic", "Super"],
    "Spongebob": ["Yellow", "Sponge", "Ocean", "Square", "Cartoon", "Underwater", "Happy", "Pants", "Pineapple"],
    "Shrek": ["Ogre", "Green", "Swamp", "Donkey", "Movie", "Princess", "Fairy", "Ugly", "Giant"],
    "Buzz Lightyear": ["Space", "Ranger", "Toy", "Fly", "Laser", "Infinity", "Disney", "Pixar", "Wings"],
    "Woody": ["Cowboy", "Toy", "Sheriff", "Hat", "Disney", "Pixar", "Andy", "Pull", "String"],

    // PROFESSIONS
    "Doctor": ["Medicine", "Hospital", "Heal", "Stethoscope", "White", "Sick", "Care", "Medical", "Diagnose"],
    "Teacher": ["School", "Educate", "Class", "Students", "Lesson", "Learn", "Desk", "Explain", "Grade"],
    "Chef": ["Cook", "Food", "Kitchen", "Hat", "Restaurant", "Recipe", "Culinary", "Prepare", "Taste"],
    "Police Officer": ["Law", "Badge", "Uniform", "Protect", "Crime", "Safety", "Gun", "Patrol", "Arrest"],
    "Firefighter": ["Fire", "Rescue", "Hose", "Brave", "Ladder", "Helmet", "Emergency", "Water", "Save"],
    "Pilot": ["Fly", "Airplane", "Cockpit", "Sky", "Captain", "Wings", "Travel", "Navigate", "Uniform"],
    "Nurse": ["Hospital", "Care", "Medicine", "Scrubs", "Help", "Patients", "Medical", "Shots", "Health"],
    "Engineer": ["Build", "Design", "Technical", "Math", "Problem", "Create", "Science", "Plans", "Smart"],
    "Lawyer": ["Law", "Court", "Case", "Justice", "Argue", "Defend", "Suit", "Legal", "Rights"],
    "Dentist": ["Teeth", "Drill", "Clean", "Mouth", "Chair", "Cavity", "Floss", "Check", "White"],
    "Musician": ["Music", "Play", "Instrument", "Song", "Perform", "Sound", "Concert", "Talent", "Compose"],
    "Actor": ["Movies", "Stage", "Perform", "Character", "Film", "Theater", "Script", "Famous", "Scene"],
    "Athlete": ["Sports", "Compete", "Fit", "Train", "Win", "Strong", "Game", "Physical", "Team"],
    "Artist": ["Paint", "Create", "Canvas", "Draw", "Creative", "Color", "Gallery", "Expression", "Brush"],
    "Scientist": ["Research", "Lab", "Experiment", "Discovery", "Smart", "Test", "Data", "Study", "Theory"],
    "Farmer": ["Crops", "Field", "Grow", "Animals", "Harvest", "Agriculture", "Rural", "Plant", "Barn"],
    "Mechanic": ["Fix", "Car", "Tools", "Engine", "Repair", "Garage", "Oil", "Wrench", "Vehicle"],
    "Architect": ["Design", "Building", "Blueprint", "Structure", "Plan", "Draw", "Creative", "Construction", "Space"],
    "Plumber": ["Pipes", "Water", "Fix", "Leak", "Wrench", "Drain", "Toilet", "Tools", "Flow"],
    "Electrician": ["Wires", "Power", "Electric", "Fix", "Voltage", "Circuit", "Light", "Safety", "Install"],

    // VEHICLES
    "Car": ["Drive", "Wheels", "Road", "Engine", "Vehicle", "Steering", "Gas", "Transport", "Four"],
    "Airplane": ["Fly", "Sky", "Wings", "Pilot", "Airport", "Jet", "Travel", "Passengers", "Fast"],
    "Boat": ["Water", "Float", "Sail", "Ocean", "Ship", "Hull", "Navigate", "Anchor", "Waves"],
    "Train": ["Tracks", "Rail", "Station", "Fast", "Cars", "Engine", "Passengers", "Long", "Whistle"],
    "Helicopter": ["Fly", "Rotor", "Blades", "Hover", "Sky", "Pilot", "Vertical", "Rescue", "Loud"],
    "Motorcycle": ["Bike", "Two", "Fast", "Ride", "Engine", "Helmet", "Road", "Speed", "Lean"],
    "Bus": ["Large", "Passengers", "Public", "Stop", "Wheels", "School", "City", "Transport", "Yellow"],
    "Truck": ["Large", "Cargo", "Heavy", "Haul", "Big", "Wheels", "Load", "Drive", "Delivery"],
    "Submarine": ["Underwater", "Ocean", "Dive", "Deep", "Periscope", "Navy", "Pressure", "Torpedo", "Submerge"],
    "Rocket": ["Space", "Launch", "Fast", "Fuel", "Sky", "Astronaut", "Blast", "NASA", "Moon"],
    "Ambulance": ["Emergency", "Siren", "Medical", "Hospital", "Rescue", "Fast", "Paramedic", "Red", "Help"],
    "Taxi": ["Ride", "Yellow", "City", "Hire", "Driver", "Fare", "Transport", "Cab", "Meter"],
    "Scooter": ["Ride", "Small", "Two", "Kick", "Stand", "Wheels", "Fast", "Balance", "Electric"],
    "Hot Air Balloon": ["Float", "Sky", "Basket", "Air", "Colorful", "High", "Gentle", "View", "Drift"],
    "Yacht": ["Boat", "Luxury", "Ocean", "Sail", "Rich", "Large", "Water", "Deck", "Expensive"],

    // TECHNOLOGY
    "Computer": ["Screen", "Keyboard", "Mouse", "Technology", "Work", "Internet", "Digital", "Software", "Desktop"],
    "Tablet": ["Screen", "Touch", "Portable", "Apps", "Digital", "Flat", "Swipe", "Battery", "iPad"],
    "Television": ["Screen", "Watch", "Show", "Remote", "Channel", "Entertainment", "Display", "Broadcast", "Living"],
    "Robot": ["Machine", "Artificial", "Metal", "Automatic", "Future", "Technology", "Program", "Mechanical", "Smart"],
    "Drone": ["Fly", "Camera", "Remote", "Quadcopter", "Air", "Technology", "Aerial", "Hover", "Record"],
    "Video Game Console": ["Play", "Games", "Controller", "Screen", "Entertainment", "Console", "Digital", "Fun", "Graphics"],
    "Smartwatch": ["Watch", "Wrist", "Time", "Digital", "Fitness", "Notifications", "Screen", "Tech", "Apple"],
    "VR Headset": ["Virtual", "Reality", "Goggles", "3D", "Immersive", "Technology", "Game", "Experience", "Wear"],
    "Speaker": ["Sound", "Audio", "Music", "Loud", "Bluetooth", "Play", "Volume", "Bass", "Wireless"],
    "Printer": ["Paper", "Print", "Ink", "Copy", "Office", "Document", "Machine", "Text", "Scan"],
    "Keyboard": ["Type", "Keys", "Letters", "Computer", "Input", "QWERTY", "Press", "Mechanical", "Click"],
    "Mouse": ["Click", "Pointer", "Computer", "Cursor", "Scroll", "Button", "Desktop", "Control", "Wireless"],
    "Charger": ["Power", "Battery", "Plug", "Cable", "Electric", "Recharge", "Phone", "Wire", "USB"],
    "Remote Control": ["Buttons", "Television", "Wireless", "Change", "Control", "Distance", "Point", "Channel", "Battery"],
    "GPS": ["Location", "Navigation", "Map", "Satellite", "Direction", "Guide", "Travel", "Coordinates", "Position"],

    // NATURE & WEATHER
    "Rainbow": ["Colorful", "Arc", "Rain", "Sky", "Seven", "Spectrum", "Beautiful", "Light", "After"],
    "Lightning": ["Electric", "Flash", "Thunder", "Storm", "Bolt", "Sky", "Bright", "Strike", "Dangerous"],
    "Volcano": ["Mountain", "Lava", "Erupt", "Hot", "Magma", "Ash", "Fire", "Dangerous", "Crater"],
    "Earthquake": ["Shake", "Ground", "Tremor", "Disaster", "Plates", "Rumble", "Dangerous", "Fault", "Magnitude"],
    "Tornado": ["Wind", "Spin", "Funnel", "Storm", "Destroy", "Twist", "Dangerous", "Cyclone", "Fast"],
    "Hurricane": ["Storm", "Wind", "Rain", "Ocean", "Powerful", "Cyclone", "Dangerous", "Eye", "Tropical"],
    "Sunset": ["Sky", "Evening", "Orange", "Beautiful", "Horizon", "Dusk", "Colors", "West", "End"],
    "Moon": ["Night", "Sky", "Orbit", "Crater", "Lunar", "Phases", "Silver", "Space", "Earth"],
    "Stars": ["Night", "Sky", "Twinkle", "Space", "Bright", "Constellation", "Distant", "Light", "Galaxy"],
    "Clouds": ["Sky", "White", "Float", "Weather", "Fluffy", "Rain", "Vapor", "Above", "Soft"],
    "Rain": ["Water", "Drops", "Fall", "Wet", "Weather", "Umbrella", "Sky", "Drizzle", "Storm"],
    "Snow": ["Cold", "White", "Winter", "Flakes", "Ice", "Fall", "Frozen", "Powder", "Melt"],
    "Thunder": ["Loud", "Storm", "Sound", "Lightning", "Boom", "Sky", "Rumble", "After", "Crash"],
    "Wind": ["Air", "Blow", "Breeze", "Move", "Gust", "Weather", "Strong", "Feel", "Trees"],
    "Fog": ["Mist", "Thick", "Gray", "Cloud", "Ground", "Dense", "Vision", "Morning", "Damp"],

    // ENTERTAINMENT
    "Star Wars": ["Space", "Force", "Jedi", "Movie", "Saga", "Lightsaber", "Galaxy", "Epic", "Franchise"],
    "Marvel": ["Superhero", "Comics", "Movies", "Universe", "Characters", "Action", "Avengers", "Powers", "Franchise"],
    "Disney": ["Movies", "Magic", "Animation", "Princess", "Mickey", "Entertainment", "Parks", "Family", "Dreams"],
    "Netflix": ["Streaming", "Movies", "Shows", "Watch", "Online", "Binge", "Series", "Subscription", "Screen"],
    "YouTube": ["Videos", "Watch", "Online", "Channel", "Content", "Stream", "Upload", "Subscribe", "Play"],
    "TikTok": ["Videos", "Short", "Social", "Dance", "Viral", "App", "Trends", "Music", "Create"],
    "Instagram": ["Photos", "Social", "Share", "Post", "Filter", "Stories", "Like", "App", "Visual"],
    "Spotify": ["Music", "Streaming", "Songs", "Listen", "Playlist", "Audio", "Artists", "Albums", "App"],
    "Minecraft": ["Game", "Blocks", "Build", "Creative", "Craft", "Mine", "Sandbox", "Pixel", "World"],
    "Fortnite": ["Game", "Battle", "Shoot", "Online", "Dance", "Build", "Victory", "Popular", "Royale"],
    "Pokemon": ["Creatures", "Catch", "Game", "Pikachu", "Battle", "Japanese", "Collect", "Trainer", "Franchise"],
    "The Beatles": ["Band", "Music", "British", "Rock", "Legendary", "Four", "Liverpool", "Classic", "Songs"],
    "Game of Thrones": ["Show", "Dragons", "Fantasy", "Throne", "Medieval", "Epic", "Series", "Battles", "Winter"],
    "Friends": ["Show", "Sitcom", "Comedy", "Six", "New York", "Coffee", "Apartment", "Popular", "Ross"],
    "The Office": ["Show", "Sitcom", "Comedy", "Work", "Paper", "Mockumentary", "Michael", "Dunder", "Scranton"],
};

// Helper function to get hints for a word
export const getHintsForWord = (word) => {
    return wordHints[word] || [];
};

// Helper function to get N random unique hints for a word
export const getRandomHints = (word, count) => {
    const allHints = wordHints[word] || [];
    if (allHints.length === 0) return [];
    
    const shuffled = [...allHints].sort(() => Math.random() - 0.5);
    return shuffled.slice(0, Math.min(count, allHints.length));
};

// Helper to get unique hint for each imposter
export const getUniqueHintsForImposters = (word, numImposters) => {
    const allHints = wordHints[word] || [];
    if (allHints.length < numImposters) {
        console.warn(`Not enough hints for ${word}. Need ${numImposters}, have ${allHints.length}`);
        return allHints.slice(0, numImposters);
    }
    
    const shuffled = [...allHints].sort(() => Math.random() - 0.5);
    return shuffled.slice(0, numImposters);
};
